import { BoundaryType } from '../interpolation-manager/types';
import type { MetadataPayload } from '../studio-store/types';
import { isFrameInAnySpan } from './frame-span-utils';
export type BoundaryResult = {
  frameIndex: number;
  type: BoundaryType;
};
export function findInterpolationBoundaries(frameIndex: number, metadata: MetadataPayload): {
  left: BoundaryResult | null;
  right: BoundaryResult | null;
} {
  const span = metadata.spans.find(s => s.start <= frameIndex && s.end >= frameIndex);
  if (!span) {
    return {
      left: null,
      right: null
    };
  }
  const otherKeyframes = metadata.keyframes.filter(k => k.frameIndex !== frameIndex && isFrameInAnySpan(k.frameIndex, [span]));
  const leftKeyframes = otherKeyframes.filter(k => k.frameIndex < frameIndex);
  let left: BoundaryResult | null = null;
  if (leftKeyframes.length > 0) {
    left = {
      frameIndex: Math.max(...leftKeyframes.map(k => k.frameIndex)),
      type: BoundaryType.KeyFrame
    };
  } else if (span.start < frameIndex) {
    left = {
      frameIndex: span.start,
      type: BoundaryType.SpanBoundary
    };
  }
  const rightKeyframes = otherKeyframes.filter(k => k.frameIndex > frameIndex);
  let right: BoundaryResult | null = null;
  if (rightKeyframes.length > 0) {
    right = {
      frameIndex: Math.min(...rightKeyframes.map(k => k.frameIndex)),
      type: BoundaryType.KeyFrame
    };
  } else if (span.end > frameIndex) {
    right = {
      frameIndex: span.end,
      type: BoundaryType.SpanBoundary
    };
  }
  return {
    left,
    right
  };
}